import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { costingTabInfo } from 'features/costing/utils';

import { setActiveTabInfo } from '@store/actions/CostingAction';
import { clearGlobalFilter } from '@store/actions/FilterAction';

const InnerTabsForNitexStudio = () => {
	const activeTabInfo = useSelector((store) => store.costingStore.activeTabInfo);
	const dispatch = useDispatch();

	const handleTabClick = (tabKey) => {
		dispatch(setActiveTabInfo(costingTabInfo[tabKey]));
		dispatch(clearGlobalFilter());
	};
	return (
		<div>
			<ul>
				<li
					className={`${activeTabInfo?.activeTabName === 'DESIGN_STUDIO_PENDING' ? 'active' : ''}`}
					onClick={() => handleTabClick('DESIGN_STUDIO_PENDING')}
				>
					Pending
				</li>
				<li
					className={`${
						activeTabInfo?.activeTabName === 'DESIGN_STUDIO_IN_REVIEW' ? 'active' : ''
					}`}
					onClick={() => handleTabClick('DESIGN_STUDIO_IN_REVIEW')}
				>
					Review
				</li>
				<li
					className={`${
						activeTabInfo?.activeTabName === 'DESIGN_STUDIO_COMPLETED' ? 'active' : ''
					}`}
					onClick={() => handleTabClick('DESIGN_STUDIO_COMPLETED')}
				>
					Completed
				</li>
			</ul>
		</div>
	);
};

export default InnerTabsForNitexStudio;
